import { LitElement, html } from 'lit';
import { msg, updateWhenLocaleChanges } from '@lit/localize';
import styles from './styles';

class BuildChannelTable extends LitElement {
  static styles = styles;

  static properties = {
    builds: {
      type: Object,
    },
  };

  constructor() {
    super();
    updateWhenLocaleChanges(this);

    this.builds = {};
  }

  render() {
    if (!Object.keys(this.builds)?.length) return html``;

    return html`
      <table>
        <thead>
          <tr>
            <th>${msg('Release')}</th>
            <th>${msg('Version')}</th>
          </tr>
        </thead>
        <tbody>
          ${this.builds?.stable && html`
            <tr>
              <td>${msg('Stable')}</td>
              <td>${this.builds?.stable?.version}</td>
            </tr>
          `}

          ${this.builds?.ga && html`
            <tr>
              <td>${msg('General Availability')}</td>
              <td>${this.builds?.ga?.version}</td>
            </tr>
          `}

          ${this.builds?.ea && html`
            <tr>
              <td>${msg('Early Access')}</td>
              <td>${this.builds?.ea?.version}</td>
            </tr>
          `}
        </tbody>
      </table>
    `;
  }
}

customElements.define('tenable-build-channel-table', BuildChannelTable);
